// MonekaDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import monekadoc from './../../../../assets/images/Doctorsimages/monekadr.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'


const MonekaDoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. Moneka P | Consultant in Homeopathy & Advanced Cosmetology";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Moneka P (BHMS), a specialist in Homeopathy and modern Cosmetology. Expert in medifacials, semi-permanent makeup, and holistic internal healing. Alumna of Vinayaka Mission's Homeopathic Medical College. Book your appointment for a balanced approach to health and beauty."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "Dr. Moneka P, homeopathy doctor, clinical cosmetologist, medifacials specialist, semi-permanent makeup artist, holistic skin care, Vinayaka Mission's Homeopathic Medical College, Niveena Academy Chennai, aesthetic homeopathy, medical-grade facials, internal wellness for skin, acne treatment, pigmentation treatment"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-moneka-p-homeopathy-cosmetology");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-moneka-p-homeopathy-cosmetology");
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Moneka_P_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Moneka P</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Salem & Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Redefining beauty through a unique fusion of <strong>Holistic Health</strong> and <strong>Modern Aesthetics</strong>. 
                    Dr. Moneka P offers a dual-layered approach to wellness, ensuring that patients achieve vibrant external results 
                    by stabilizing internal health triggers.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={monekadoc} alt="Dr. Moneka P – Homeopathy & Cosmetology Specialist" className="veenadoc-doctor-image" title='Dr. Moneka P – Homeopathy & Cosmetology Specialist' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Moneka P</h2>
                  <p>
                    Dr. Moneka P (BHMS) is a dedicated Consultant in Homeopathy and Cosmetology who brings a fresh, integrative perspective to patient care. 
                    She earned her medical degree from the renowned <strong>Vinayaka Mission's Homeopathic Medical College and Hospital</strong> in Salem, 
                    establishing a strong foundation in clinical medicine and constitutional prescribing.
                  </p>
                  <p>
                    Recognizing that the skin is often a mirror of internal health, Dr. Moneka expanded her expertise by pursuing specialized training 
                    at the <strong>Niveena Academy in Chennai</strong>. There, she completed an advanced certificate course in Cosmetology, 
                    mastering high-end procedures such as Medifacials and Semi-Permanent Makeup.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS (Vinayaka Mission's)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Cosmetology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Certification:</span>
                      <span className="veenadoc-info-value">Niveena Academy, Chennai</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Key Expertise:</span>
                      <span className="veenadoc-info-value">Medifacials & SPMU</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>A Fusion of Science and Aesthetics</h2>
                  <p>
                    Dr. Moneka’s treatment philosophy centers on the belief that <strong>"Enhancement is most effective when supported by health."</strong> 
                    While many aesthetic treatments focus solely on surface-level changes, Dr. Moneka utilizes her homeopathic expertise to address 
                    internal triggers—such as hormonal imbalances, nutritional deficiencies, or stress—that often manifest as skin problems.
                  </p>
                  <p>
                    By stabilizing these internal factors, she ensures that the results of her cosmetic procedures are not only more vibrant 
                    but also significantly more sustainable over time.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Clinical Cosmetology Expertise</h2>
                  <p>In her cosmetology practice, Dr. Moneka specializes in several advanced areas:</p>
                  <ul>
                    <li>
                      <strong>Medifacials:</strong> Unlike traditional salon facials, these utilize medical-grade techniques to treat 
                      dehydration, aging, and congestion at a deeper cellular level.
                    </li>
                    <li>
                      <strong>Semi-Permanent Makeup (SPMU):</strong> Offering expert precision in enhancing facial features with 
                      long-lasting, natural-looking results for those seeking aesthetic convenience.
                    </li>
                    <li>
                      <strong>Integrative Skin Care:</strong> A combined approach where homeopathic remedies treat acne and pigmentation 
                      from within, while clinical procedures provide immediate external improvement.
                    </li>
                  </ul>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Constitutional Homeopathy for Chronic Care</h2>
                  <p>
                    Beyond aesthetics, Dr. Moneka remains deeply committed to her roots in Homeopathy. She specializes in 
                    <strong>Constitutional Homeopathy</strong>, treating chronic ailments and systemic health issues through 
                    personalized remedies. This approach promotes the body’s innate self-healing capabilities, ensuring 
                    long-term wellness rather than just symptom suppression.
                  </p>
                  <p>
                    Whether dealing with lifestyle-induced disorders, skin allergies, or hair loss, her homeopathic prescriptions 
                    are tailored to the individual's unique physical and emotional makeup.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Moneka P?</h2>
                  <p>
                    Patients who consult Dr. Moneka appreciate her meticulous attention to detail and her ability to create 
                    highly personalized treatment plans. As an alumna of Vinayaka Mission, she remains committed to the 
                    highest standards of medical ethics and patient safety.
                  </p>
                  <p>
                    Choosing Dr. Moneka means choosing a practitioner who sees the <strong>"whole person."</strong> Her mission 
                    is to empower her patients by restoring their health and enhancing their natural features through a 
                    balanced, scientific, and compassionate approach.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Commitment to Excellence</h2>
                  <p>
                    Her expertise in semi-permanent makeup and medifacials is backed by a deep understanding of skin anatomy 
                    and physiology, ensuring that every procedure is performed with medical-grade care in a safe, clinical environment.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her Mission:</strong> To provide a sanctuary where health and aesthetics coexist, helping patients 
                    achieve their beauty goals without compromising their long-term well-being.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "Enhancement is most effective when supported by health."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Moneka P's Care Philosophy</p>
                  </div>
                  <p>
                    True beauty radiates from within. By addressing the root medical cause of skin and hair issues, 
                    we achieve results that are both beautiful and healthy.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Specialized Treatments</h3>
                  <ul className="veenadoc-services-list">
                    <li>✨ Medical Grade Facials</li>
                    {/* <li>💄 Semi-Permanent Makeup</li> */}
                    <li>🌿 Constitutional Homeopathy</li>
                    <li>🎯 Acne & Pigmentation Control</li>
                    <li>💇‍♀️ Hair Loss Management</li>
                    <li>🧪 Integrative Skin Science</li>
                  </ul>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Salem</h4>
                      <p>Primary Clinical Practice</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai</h4>
                      <p>Advanced Aesthetic Consultations</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience the perfect balance of internal health and external beauty.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => navigate('/bookconsultation')}>
                    <span>💬</span>
                    <span>Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Moneka's Profile as PDF
        </button>
      </div>
    </>
  )
}

export default MonekaDoc
